import React from 'react';

// Footer stateless component
const Footer = () =>
	<footer className="level is-fixed-bottom">
		<div className="level-left">
			<p className="level-item column is-2-tablet is-1-desktop is-1-widescreen"></p>
		</div>
	</footer>

export default Footer;




// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js